export const API_PATHS = {
    RECRUITMENT_ATTACHMENTS_UPLOAD: "api/recruitment/attachments",
    RECRUITMENT_DEPARTMENTS:"api/recruitment/departments/",
    RECRUITMENT_PROFILES:"api/recruitment/profiles/",
    USER:"api/user/",
    POST_RECRUITMENT_PROFILES:"api/recruitment/profiles",
    PASSWORD_UPDATE_PERMISSION:"api/password/update-permission"
};